<template>
  <div class="home-content">
    <about
      data-aos="fade-in"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="500"
      data-aos-easing="ease-in-out">
    </about>
    <skills
      data-aos="fade-up"
      data-aos-offset="100"
      data-aos-delay="50"
      data-aos-duration="900"
      data-aos-easing="ease-in-out">
    </skills>
    <contact
      data-aos="fade-in"
      data-aos-delay="50"
      data-aos-duration="800"
      data-aos-easing="ease-in-out">
    </contact>
  </div>
</template>
<script>
import About from '@/components/About.vue'
const Skills = () => import('@/components/Skills.vue')
const Contact = () => import('@/components/Contact.vue')
export default {
  name: 'Home',
  components: {
    About,
    Skills,
    Contact
  }
}
</script>
<style>
.home-content {
  display: grid;
  grid-gap: 75px;
  justify-content: center;
  grid-template-areas: "about about"
                    "background background"
                    "skills skills"
                    "work work"
                    "contact contact";
}

@media screen and (max-width: 700px){
.home-content {
    grid-gap: 50px;
  }
}
</style>
